const type = {
  NEWS: 1,
  VIDEO: 2
};

export default type;
